import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'loading',
    props: {
        loadingMessage: String
    },
    setup: function () {

        return {

        };
    }
});